<template>
  <div class="legend-container">
    <div class="legend-title">凡例</div>

    <div class="legend-items">

      <div class="legend-item" style="margin-bottom: 8px">
        <div class="row-items">
          <div style="width:35px; display: flex; justify-content: center;">
            <div class="point_example"/>
          </div>
          <div class="legend-text">協議済み（実測図閲覧可）</div>
        </div>
      </div>

      <div class="legend-item" style="margin-bottom: 2px">
        <div class="row-items">
          <div style="width:35px; height: 12px; background-color: pink; align-content: center; justify-content: center;">
            <div class="border-blue"/>
          </div>
          <div class="legend-text">整備促進路線</div>
        </div>

        <div class="row-items">
          <div style="width:35px; height: 12px;" />
          <div class="legend-text-sm" style="top: 0px;"> 中央の線が⻘以外の場合もあります </div>
        </div>

      </div>


    </div>
  </div>
</template>

<script>
export default {
  name: 'MapObjectGuideKyoai'
}
</script>

<style scoped>
.legend-container {
  background: #ddeeee;
  padding: 16px;
  border-radius: 8px;
  max-width: 360px;
}

.legend-title {
  text-align: center;
  font-weight: bold;
  margin-bottom: 16px;
  font-size: 0.9rem;
}

.legend-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.legend-item {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 2px;
}

.row-items {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}


.point_example {
  width: 10px;
  height: 10px;
  position: relative;
  border: 0.5px solid;
  border-radius: 10px;
  border-color: rgb(0,0,255,0.5) !important; 
  background-color: rgba(0,0,255,0.3) !important;
}

.legend-container .legend-items .legend-item .colorbox_border {
  background-color: white;
}

.border-blue { 
  width: 35px;
  border: 2px solid;
  position: relation;
  border-color: rgb(0,0,255) !important; 
}

.background-border-pink { 
  width: 35px;
  height: 10px;
  position: absolute;
  background-color: rgb(255, 138, 230) !important; 
}

.legend-text {
  font-size: 0.8rem;
}

.legend-text-sm {
  font-size: 0.6rem;
  color: 	#333333;
}
</style> 